import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"
import { loginFacebook, signUpFacebook } from "store/auth/action"
import { AUTH_TYPES } from "constants/auth-types"
import { FACEBOOK_APP_KEY } from "constants/config"
import styled from "styled-components"

export const StyledVerificationPopUp = styled.button`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  margin: 5px 0;
  opacity: 0.85;
  display: inline-block;
  font-size: 17px;
  line-height: 20px;
  text-decoration: none;
  background-color: #4267b2;
  color: white;
  :hover: {
    background-color: #30497c;
  }
`
class FacebookButton extends Component {
  responseFacebook = (response) => {
    console.log("response", response)
    if (response) {
      const {
        school: { schoolData },
        type,
        signUpFacebook,
        loginFacebook,
      } = this.props
      const data = {
        access_token: response.accessToken,
      }
      if (type === AUTH_TYPES.REGISTER) {
        data.role = "ST"
        data.school_id = schoolData?.id
        signUpFacebook(data)
      } else {
        loginFacebook(data)
      }
    }
  }

  render() {
    const { type } = this.props
    return (
      <FacebookLogin
        appId={FACEBOOK_APP_KEY}
        autoLoad={false}
        callback={this.responseFacebook}
        render={(renderProps) => (
          <button className="fb" onClick={renderProps.onClick}>
            {type === AUTH_TYPES.REGISTER
              ? "Continue with Facebook"
              : "Login with Facebook"}
          </button>
        )}
        scope="public_profile,email,groups_access_member_info"
      />
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginFacebook,
      signUpFacebook,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  FacebookButton
)
